import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { INSURANCE_DETAILS } from './constants/coverage-detail.constant';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-insurance-coverage-modal',
  templateUrl: './insurance-coverage-modal.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class InsuranceCoverageModalComponent {
  readonly details = INSURANCE_DETAILS;

  constructor(public readonly activeModal: NgbActiveModal) {}
}
